import React, { useState, useEffect } from "react";
import { Drawer } from "@blueprintjs/core";
import Flexbox from "flexbox-react";
import StepProcessList from "./StepProcessList";
import StepDialog from "./StepDialog";
import axios from "axios";
import Cookies from "js-cookie";
import ToastStore from "../../stores/ToastStore";
import StepProcessQuestionManager from "./StepProcessQuestionManager";
import "../goals/GoalSettingsCreateForm.css";
import { Spinner } from "@blueprintjs/core";
import { Icon } from "@blueprintjs/core";
//import StepContentRenderer from "./StepContentRenderer";

const StepProcessDrawer = ({ isOpen, onClose, goalCycleId, isWeightAllow }) => {

  const [loadingSteps, setLoadingSteps] = useState(false);
  const [loadingQuestions, setLoadingQuestions] = useState(false);

  const [steps, setSteps] = useState([]);
  const [activeStep, setActiveStep] = useState(steps[0]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editingStep, setEditingStep] = useState(null);
  const [jobProfiles, setJobProfiles] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [isLoading, setIsLoading] = useState(false);


  useEffect(() => {
    fetchJobProfiles();
    fetchEmployees();
  }, []);

  useEffect(() => {
    if (!goalCycleId) return;

    fetchStepsList();
  }, [goalCycleId]);

  const fetchJobProfiles = () => {
    axios.get(`${Cookies.get("apiEnv")}/job_profiles`)
      .then(response => {

        const profiles = Array.isArray(response.data) ? response.data : [];
        setJobProfiles(profiles);
      })
      .catch(error => {
        console.error("Error fetching job profiles", error);
      });
  }

  const fetchEmployees = () => {
    axios.get(`${Cookies.get("apiEnv")}/users?page=1&per_page=25&offset=0`)
      .then(response => {

        const employees = Array.isArray(response.data) ? response.data : [];
        setEmployees(employees);
      })
      .catch(error => {
        console.error("Error fetching employees", error);
      });
  }
  // Add / Edit dialog open
  const openAddDialog = () => {
    setEditingStep(undefined);
    setDialogOpen(true);
  };

  const openEditDialog = (step) => {
    setEditingStep(step);
    setDialogOpen(true);
  };

  // Save step
  const handleSaveStep = async (payload) => {
    try {
      const allowPreviousEditing =
        Number(payload.step_type) === 1
          ? 0
          : (payload.allow_previous_step_editing ? 1 : 0);

      const requestPayload = {
        step_name: payload.step_name,
        step_type: payload.step_type,
        allow_previous_step_editing: allowPreviousEditing,
        assign_type: payload.assign_type,
        assignee_list: payload.assignee_list,

        // ADD THESE
        allow_question_reuse: payload.allow_question_reuse,
        step_id_to_reuse: payload.allow_question_reuse
          ? payload.step_id_to_reuse
          : null
      };

      if (editingStep) {
        await axios.put(
          `${Cookies.get("apiEnv")}/performance_steps/${editingStep.id}?goal_setting_id=${goalCycleId}`,
          requestPayload
        );
      } else {
        await axios.post(
          `${Cookies.get("apiEnv")}/performance_steps`,
          {
            ...requestPayload,
            goal_setting_id: goalCycleId
          }
        );
      }

      fetchStepsList();
      setDialogOpen(false);

      ToastStore.showToast(
        editingStep
          ? "Step updated successfully"
          : "Step saved successfully",
        "success"
      );

    } catch (error) {
      console.error(error);
      ToastStore.showToast("Failed to save step", "error");
    }
  };

  const fetchStepsList = (movedStepId = null) => {
    try {
      setLoadingSteps(true);
      axios.get(`${Cookies.get("apiEnv")}/performance_steps?goal_setting_id=${goalCycleId}`)
        .then(response => {
          console.log("steps", response.data);
          const steps = Array.isArray(response.data) ? response.data : [];
          setSteps(steps);
          if (movedStepId) {
            setActiveStep(steps.find(s => s.id === movedStepId));
          } else {
            setActiveStep(steps[0]);
          }

        })

        .catch(error => {
          console.error("Error fetching steps", error);
          setLoadingSteps(false);
        })
        .finally(() => {
          setLoadingSteps(false);
        });
    } catch (error) {
      console.error("Error fetching steps", error);
      setLoadingSteps(false);
    }
  };

  const handleDelete = (id) => {
    const updated = steps.filter((s) => s.id !== id);
    setSteps(updated);
    if (activeStep?.id === id) setActiveStep(updated[0]);
    axios.delete(`${Cookies.get("apiEnv")}/performance_steps/${id}?goal_setting_id=${goalCycleId}`)
      .then(response => {
        console.log("deleted step", response.data);
        fetchStepsList();
        ToastStore.showToast("Step deleted successfully", "success");
      })
      .catch(error => {
        console.error("Error deleting step", error);
        ToastStore.showToast("Failed to delete step", "error");
      });
  };

  // const handleReorder = (newSteps) => {
  //   setSteps(newSteps);
  // };

  const handleReorder = async (newSteps, movedStepId, newIndex) => {
    setSteps(newSteps);
    const movedStep = newSteps.find(s => s.id === movedStepId);
    try {
      await axios.put(
        `${Cookies.get("apiEnv")}/performance_steps/${movedStepId}?goal_setting_id=${goalCycleId}`,
        {
          position: newIndex + 1
        }
      );

      fetchStepsList(movedStepId);
    } catch (error) {
      fetchStepsList();
    }
  };



  return (

    <Drawer isOpen={isOpen} onClose={onClose} size="89%" title="Step Process" portalContainer={document.body}>
      {/* <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          marginBottom: "16px",
          padding: "12px 16px",
          background: "#f5f9ff",
          border: "1px dashed #90caf9",
          borderRadius: "10px",
          color: "#3366cc",
          fontSize: "14px",
          fontWeight: 500,
        }}
      >
        <Icon
          icon="drag-handle-vertical"
          size={18}
          style={{
            color: "#5f6b7c",
            cursor: "grab",
            flexShrink: 0,
          }}
        />

        <span>
          You can drag & drop steps to reorder the process flow
        </span>
      </div> */}
      {!loadingSteps ? (
        <div style={{ padding: 20, background: "#fff" }}>

          {/* STEP PROCESS LIST */}
          <StepProcessList
            steps={steps}
            activeStep={activeStep}
            onStepClick={(id) => setActiveStep(steps.find(s => s.id === id))}
            onEdit={openEditDialog}
            onDelete={handleDelete}
            onAdd={openAddDialog}
            onReorder={handleReorder}
          />

          {/* STEP CONTENT */}
          <StepProcessQuestionManager
            goalCycleId={goalCycleId}
            stepProcessId={activeStep?.id}
            isWeightAllow={isWeightAllow}
            jobProfileList={jobProfiles}
          />

          {/* ADD / EDIT DIALOG */}
          <StepDialog
            isOpen={dialogOpen}
            onClose={() => setDialogOpen(false)}
            onSave={handleSaveStep}
            initialData={editingStep}
            jobProfileList={jobProfiles}
            employeeList={employees}
            stepsList={steps}
            goalCycleId={goalCycleId}
          />
        </div>
      ) : (
        <div>

          <Flexbox flexGrow={1} flexDirection="column" justifyContent="center" alignItems="center" style={{ marginTop: "230px" }}>
            <img
              style={{ height: "35px", width: "35px" }}
              src="https://s01.live2support.com/dashboardv2/chatassets/img/loader_new.gif"
              alt="Please wait"
            />
          </Flexbox>
        </div>
      )}
    </Drawer>
  );
};

export default StepProcessDrawer;